export default "__VITE_ASSET__DBcXnWI8__"